export default __webpack_public_path__ + "static/media/kasparov-on-my-great-predecessors-1.c25ceac3.txt";